import * as React from 'react';
import { StyleSheet } from 'react-native';
import Animated, { useAnimatedScrollHandler } from 'react-native-reanimated';
import { HEIGHT_PLUS_PADDING } from 'design-system/Button';
import { Indicator, SCROLL_INDICATOR_INSETS, Spacer } from 'design-system';
import { useAppSelector } from 'store/hooks';
import { useMarginBottom } from 'hooks/useMarginBottom';
import useAppFrameDimensions from 'hooks/useAppFrameDimensions';
import AARNote from 'features/invest/components/AARNote';
import { selectSecclGiaReadyMadeFunds } from '../reducers/selectors';
import ReadyMadeFund from './ReadyMadeFund';
import { isWeb } from '../../../constants';
const ReadyMadeFundsView = ({ scrollY }) => {
    const { paddingHorizontalStyle } = useAppFrameDimensions(isWeb);
    const paddingBottom = useMarginBottom('paddingBottom', HEIGHT_PLUS_PADDING, paddingHorizontalStyle);
    const assetIds = useAppSelector(selectSecclGiaReadyMadeFunds);
    const scrollHandler = useAnimatedScrollHandler((handle) => {
        // eslint-disable-next-line no-param-reassign
        scrollY.value = handle.contentOffset.y;
    }, []);
    if (!assetIds?.length) {
        return <Indicator dark style={styles.indicator}/>;
    }
    return (<Animated.ScrollView onScroll={scrollHandler} scrollEventThrottle={16} keyboardShouldPersistTaps="handled" contentContainerStyle={paddingBottom} scrollIndicatorInsets={SCROLL_INDICATOR_INSETS}>
      {assetIds.map((assetId) => (<ReadyMadeFund key={assetId} assetId={assetId}/>))}
      <Spacer.H8 />
      <AARNote />
    </Animated.ScrollView>);
};
export default React.memo(ReadyMadeFundsView);
const styles = StyleSheet.create({
    indicator: {
        marginBottom: '20%',
    },
});
